/*
 * @Author: cui
 * @Date: 2020-08-03
 * */

const types = {
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
  OPEN_LOADING: "OPEN_LOADING",
  CLOSE_LOADING: "CLOSE_LOADING",
  SET_CITYNAME: "SET_CITYNAME",
};

export default types;
